export enum EnumAuthState {
  /** Экран входа: одно поле для сид-фразы или PIN */
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  /** Учётная запись без PIN задаёт их один раз после входа по фразе */
  PINS = 'PINS',
}
